<div #baChartistChart class="ba-chartist-chart {{baChartistChartClass || ''}}"></div>
